import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, NavLink, withRouter } from "react-router-dom";
import { Layout } from "antd";

import appActions from "../../redux/app/actions";
// import IntlMessages from "../../components/utility/intlMessages";
import TopbarUser from "./topbarUser";
import TopbarWrapper from "./topbar.style";
import themes from "../../settings/themes";
import { themeConfig } from "../../settings";
import SidebarHorizontal from "../Sidebar/SidebarHorizontal";
import "./customTopbar.css";

const { Header } = Layout;
const { toggleCollapsed } = appActions;
const customizedTheme = themes[themeConfig.theme];

class Topbar extends Component {
  render() {
    const { toggleCollapsed, url } = this.props;
    const appWidth = window.innerWidth < 576 ? true : false;
    const collapsed = this.props.collapsed && !this.props.openDrawer;
    const styling = {
      background: customizedTheme.backgroundColor,
      position: "fixed",
      width: "100%",
      height: 60,
      top: 0,
    };

    let dashboardView = this.props.dashboardView.dashboardStatus
      ? "sidebar-logos dashboard-view"
      : "sidebar-logos";
    return (
      <TopbarWrapper>
        <Header
          style={styling}
          className={
            collapsed ? "isomorphicTopbar collapsed" : "isomorphicTopbar"
          }
        >
          {/* Sidebar is intentionally empty (Sidebar.js renders <div></div>),
              so the mobile hamburger trigger has nothing to toggle. Show the
              user hero on every viewport instead — the hero CSS scales itself
              for small screens. */}
          <div
            className={dashboardView}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              height: 55,
              alignItems: "center",
            }}
          >
            {(() => {
              const dpInfo = (this.props.dashboardView && this.props.dashboardView.dpInfo) || {};
              const nameAlias = (this.props.dashboardView && this.props.dashboardView.nameAlias) || "";
              const heroName = nameAlias || "User";
              const initial = heroName !== "User" ? heroName[0].toUpperCase() : "U";
              return (
                <div className="topbar-user-hero">
                  <div className="topbar-user-av">{initial}</div>
                  <div className="topbar-user-info">
                    <div className="topbar-user-name">{heroName}</div>
                    {dpInfo.dpId && (
                      <div className="topbar-user-dpid">{dpInfo.dpId}</div>
                    )}
                  </div>
                </div>
              );
            })()}
          </div>

          <ul className="topbar-nav">
            <li>
              <NavLink
                to="/dashboard"
                className="topbar-nav-link"
                activeClassName="topbar-nav-link-active"
                isActive={(_, location) => {
                  const p = location.pathname.replace(/\/$/, "");
                  return p === "/dashboard" || p === "/dashboard/consents";
                }}
              >
                Consents
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/dashboard/manageRequest"
                className="topbar-nav-link"
                activeClassName="topbar-nav-link-active"
                isActive={(_, location) => {
                  const p = location.pathname;
                  return (
                    p.startsWith("/dashboard/manageRequest") ||
                    p.startsWith("/dashboard/addRequest")
                  );
                }}
              >
                Requests
              </NavLink>
            </li>
          </ul>

          <ul className="isoRight">
            {/* <li style={{ width: "max-content", cursor: "default" }}>
              <small>
                <IntlMessages id={"sidebar.welcome"} />,
              </small>
              <br />
              <span>
                {this.props.dashboardView.profileData.userFirstName +
                  " " +
                  this.props.dashboardView.profileData.userLastName}
              </span>
            </li> */}
            <li
              onClick={() => this.setState({ selectedItem: "user" })}
              className="isoUser"
            >
              <TopbarUser />
            </li>
          </ul>
        </Header>
        {/* {!appWidth && <SidebarHorizontal url={url}/>} */}
      </TopbarWrapper>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      ...state.App,
      dashboardView: state.Auth,
      App: state.App,
    }),
    { toggleCollapsed },
  )(Topbar),
);
